import { Mapper } from "../../../../base/utils/mapper";
import { ConsentResponseModel } from "../../../../domain/models/consult/consent-response.model";
import { ConsentResponseEntity } from "../entities/consent-response.entity";


export class ConsentByIdImplementationRepositoryMapper extends Mapper<ConsentResponseEntity, ConsentResponseModel> {
    mapFrom(param: ConsentResponseEntity): ConsentResponseModel {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        };
    }
    mapTo(param: ConsentResponseModel): ConsentResponseEntity {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        }
    }
}